import router from '@/router'
import { v1 as uuidv1 } from 'uuid';
import {doc, setDoc} from "firebase/firestore";
export default {
    state: {
        transactionObj: null

    },
    mutations: {
        setTransactionObj (state, payload) {
            state.transactionObj = payload
        },
        setListingId (state, payload) {
            state.transactionObj = payload
        },
        clearTransactionObj (state) {
            state.transactionObj = null
        }
    },
    actions: {
        setListingId({commit}, payload) {
            commit('setListingId', payload)
        },
        initCardPayment ({commit}, payload) {
            commit('setTransactionObj', payload)
        },
        newCardPaymentMade ({rootState, getters, commit}, payload) {
            commit('setLoading', true)
            let user = getters.user
            let chargeObj = payload
            chargeObj.id = uuidv1()
            chargeObj.status = 'Pending'
            // console.log(user)
            // console.log(chargeObj)
            setDoc(doc(rootState.db, 'customers', user.uid, 'cardPayments', 'stripe', 'charges', chargeObj.id), chargeObj)
                .then(() => {
                    router.push('/transactionStatus/' + chargeObj.id)
                })
                .catch(err => {
                    console.log(err)
                    commit('setError', err)
                })
        },
        chargeCardOnFile ({rootState, getters, commit}, payload) {
            commit('setLoading', true)
            let user = getters.user
            let chargeObj = payload
            chargeObj.id = uuidv1()
            chargeObj.status = 'Pending'
            //console.log(chargeObj)
            // let paymentRef = rootState.db.collection('users').doc(user.uid)
            //     .collection('cardPayments').doc('stripe').collection('charges')
            // console.log('from Payment store')
            setDoc(doc(rootState.db, 'users', user.uid, 'cardPayments', 'stripe', 'charges', chargeObj.id), chargeObj)
                .then(() => {
                    router.push('/transactionStatus/' + chargeObj.id)
                })
                .catch(err => {
                    console.log(err)
                    commit('setError', err)
                })
        },
        resetTransaction ({commit}) {
            commit('clearTransactionObj')
        }
    },
    getters: {
        transactionObj (state) {
            return state.transactionObj
        }

    }
}
